import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";
import Nav from "./Nav";
import Footer from "./Footer";

const Layout = ({ children }) => {
  const { pathname } = useLocation();

  // Smooth, weighty scroll
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  // Reset scroll on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="App relative min-h-screen bg-ivory text-ink" data-testid="site-root">
      {/* Paper grain overlay */}
      <div
        aria-hidden="true"
        className="grain-overlay pointer-events-none fixed inset-0 z-[60] opacity-[0.04] mix-blend-multiply"
      />
      <Nav />
      <main>{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
